import { Locales } from '../enum/locales';
import { IAyat } from '../interfaces/i-ayat';
import { TLocales } from '../type/locales';

export class Ayat {
  id: number;
  number: number;
  page: number;
  text: string;
  translate?: string;

  constructor(data: IAyat, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.number = data.number;
    this.page = data.page;
    this.text = data.text;
    this.translate = data.translate;
  }
}
